import M from "moment";
import React, { Component, Fragment } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import { inputConfig } from "../config/config";
import ReceivingInputs from "./receivingInputs";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { mapToObjectDDL } from "../../../../common/mapper";
import * as R from "ramda";
import {
  constructDataDetailOtherItems,
  constructGenSeqPayload,
  validateDataDetailOtherItems,
} from "../util";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ReceivingCreateUpdate extends Component {
  constructor(props) {
    super(props);
    this.contentConfig = props.contentConfig;
    this.inputConfig = inputConfig[props.tab];
    this.currentDate = M(new Date()).format("DD/MM/YYYY");
    this.tableColumns = [
      {
        name: "id",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
            return <>{tableMeta.rowIndex + 1}</>;
          },
        },
      },
      {
        name: this.contentConfig.codeName,
        label: this.contentConfig.codeLabel,
        options: {
          customBodyRender: (value, { rowIndex, rowData }) => {
            const isSaved = rowData[rowData.length - 1];
            return isSaved ? (
              <p>{value?.label}</p>
            ) : (
              <SimpleDDL
                id={`select_options_kode_hadiah_${rowIndex}`}
                containerclassname="margin-bottom-none width width-250px"
                box={"search"}
                menuPosition="fixed"
                options={this.state.dataItems.map((item) =>
                  mapToObjectDDL(item.kodeotheritem, item.kodeotheritem)
                )}
                readOnly={isSaved}
                isClearable={true}
                value={value}
                onChange={(value) =>
                  this.handleSelectCodeOtherItems(
                    rowIndex,
                    "kodeotheritem",
                    value
                  )
                }
              />
            );
          },
          sort: false,
        },
      },
      {
        name: this.contentConfig.itemName,
        label: this.contentConfig.itemLabel,
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "categoryotheritem",
        label: "Kategori",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "jumlah",
        label: "Jumlah*",
        options: {
          customBodyRender: (val, { rowIndex, rowData, columnData }) => {
            const isSaved = rowData[rowData.length - 1];
            return isSaved ? (
              <p>{val}</p>
            ) : (
              <SimpleInput
                value={val}
                containerclassname="margin-bottom-none width width-100px"
                readOnly={isSaved}
                box="onlyNumber"
                onChange={(e) =>
                  this.handleValueChange(
                    rowIndex,
                    columnData.name,
                    e.target.value
                  )
                }
              />
            );
          },
          sort: false,
        },
      },
      {
        name: "satuanotheritem",
        label: "Satuan",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "kodeLocation",
        label: "[*] All Locator",
        options: {
          customHeadRender: (props) => {
            return (
              <th className="custom-locator">
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <p>{props.label}</p>
                  <SimpleDDL
                    id="select_options_header_locator"
                    containerclassname="margin-bottom-none width width-250px"
                    box="search"
                    isClearable={true}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        position: "relative",
                        fontFamily:
                          "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                      }),
                    }}
                    options={
                      this.state.dataLocator
                        ? this.state.dataLocator.map((item) =>
                            mapToObjectDDL(item.nameLocation, item.kodeLocation)
                          )
                        : []
                    }
                    onChange={this.handleMultipleLocatorChange}
                  />
                </FlexView>
              </th>
            );
          },
          customBodyRender: (val, { rowIndex, rowData }) => {
            const isSaved = rowData[rowData.length - 1];
            return isSaved ? (
              <p>{val?.label}</p>
            ) : (
              <SimpleDDL
                id={`select_options_locator_${rowIndex}`}
                containerclassname="margin-bottom-none width width-250px"
                box="search"
                value={val}
                menuPosition="fixed"
                options={
                  this.state.dataLocator
                    ? this.state.dataLocator.map((item) =>
                        mapToObjectDDL(item.nameLocation, item.kodeLocation)
                      )
                    : []
                }
                readOnly={isSaved}
                isClearable={true}
                onChange={(value) =>
                  this.handleSingleLocatorChange(rowIndex, value)
                }
              />
            );
          },
          sort: false,
        },
      },
      {
        name: "saved",
        label: "Aksi",
        options: {
          customBodyRender: (val, { rowIndex }) => (
            <FlexView style={{ gap: "10px" }}>
              {!val ? (
                <SimpleButton
                  className={"btn background-red"}
                  styles={{ width: "unset", marginLeft: "0px" }}
                  onClick={() => this.handleSaveRow(rowIndex)}
                  icon={<i className="fa fa-save" />}
                />
              ) : (
                <SimpleButton
                  className={"btn background-red"}
                  styles={{ width: "unset", marginLeft: "0px" }}
                  onClick={() => this.handleEditRow(rowIndex)}
                  icon={<i className="fa fa-lw fa-pencil-alt" />}
                />
              )}
              <SimpleButton
                className={"btn background-red"}
                styles={{ width: "unset", marginLeft: "0px" }}
                onClick={() => this.handleDeleteRow(rowIndex)}
                icon={<i className="fa fa-trash"></i>}
              />
            </FlexView>
          ),
          sort: false,
        },
      },
    ];
    this.initialData = {
      kodeotheritem: null,
      nameotheritem: null,
      kodeotheritem: null,
      jumlah: null,
      satuanotheritem: null,
      kodeLocation: null,
      qrotheritem: null,
      numbersOfPrint: null,
      saved: false,
    };
    this.state = {
      [this.contentConfig.codeName]: null,
      warningModalVisible: false,
      dataTable: [],
      dataDetailSaved: [],
      dataSupplier: [],
      dataSupplierExpedition: [],
      dataItems: [],
      dataLocator: [],
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    this.fetchDataSupplier();
    this.fetchDataSupplierExpedition();
    let kodeCabang = this.props.selectedCabang;
    let spblNo = await this.fetchDataGenerateSeq(
      constructGenSeqPayload(kodeCabang)
    );
    this.props.setValue("spblNo", !R.isNil(spblNo) ? spblNo : null);
    this.props.setValue("kodeCabang", kodeCabang);
    this.handleTriggerLoading();
  };

  handleWarningModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleAddRow = async () => {
    try {
      if (R.isEmpty(this.state.dataItems)) {
        this.handleTriggerLoading();
        await this.fetchOtherItems();
        await this.fetchDataLocator();
        this.handleTriggerLoading();
      }

      const newUnit = {
        ...this.initialData,
        id: this.state.dataTable.length + 1,
      };
      

      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [...prevValue.dataTable, newUnit],
        dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
      }));
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleEditRow = async (index) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.dataTable];
      newState[index] = {
        ...newState[index],
        saved: !newState[index].saved,
      };

      return {
        ...prevValue,
        dataTable: newState,
      };
    });
  };

  handleSaveRow = (index) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.dataTable];
      newState[index] = {
        ...newState[index],
        saved: !newState[index].saved,
      };
      

      return {
        ...prevValue,
        dataTable: newState,
        dataDetailSaved: newState,
      };
    });
  };

  handleDeleteRow = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
      dataDetailSaved: [
        ...prevValue.dataDetailSaved.filter((_, idx) => idx !== index),
      ],
    }));
  };

  handleSelectCodeOtherItems = async (index, name, value) => {
    if (!R.isEmpty(this.state.dataItems)) {
      let otherItems = this.state.dataItems.find(
        (item) => item.kodeotheritem === value?.value
      );

      this.setState((prevValue) => {
        const newState = [...prevValue.dataTable];
        newState[index] = {
          ...newState[index],
          [name]: value,
          nameotheritem: otherItems?.nameotheritem,
          categoryotheritem: otherItems?.categoryotheritem,
          satuanotheritem: otherItems?.satuanotheritem,
          qrotheritem: otherItems?.qrotheritem,
        };

        return {
          ...prevValue,
          dataTable: newState,
        };
      });
    }
  };

  handleValueChange = (index, colName, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable];
      newState[index] = {
        ...newState[index],
        [colName]: value,
      };
      return {
        ...prevState,
        dataTable: newState,
      };
    });
  };

  handleSingleLocatorChange = (index, value) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.dataTable];
      newState[index] = {
        ...newState[index],
        kodeLocation: value,
      };
      return {
        ...prevValue,
        dataTable: newState,
      };
    });
  };

  handleMultipleLocatorChange = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      dataTable: prevState.dataTable.map((row) => {
        if (!row.saved) {
          return {
            ...row,
            kodeLocation: value,
          };
        }
        return row;
      }),
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleClearForm = () => {
    this.props.resetIgnoreKeys(["spblNo"]);
    this.props.setValue("spblDate", this.currentDate);
    this.setState((prevState) => ({
      ...prevState,
      dataTable: [],
    }));
  };

  handleSubmit = () => {
    const validateDetail = validateDataDetailOtherItems(
      this.state.dataDetailSaved
    );

    if (!this.props.validate() || !validateDetail) {
      this.handleWarningModalVisibility("Ada field data yang perlu diisi atau tidak sesuai kriteri isian.")
      return;
    }

    let details = constructDataDetailOtherItems(this.state.dataDetailSaved);
    details = details.map((item) => ({
      ...item,
      id: item.id ?? null,
    }));
    

    if (!details || details.length === 0) {
      this.handleWarningModalVisibility("Data detail barang lain tidak boleh kosong.")
      return;
    }

    this.props.onSubmit("save", this.props.controls, details);
  };

  fetchDataSupplier = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSupplierMainDealerBySourceCode,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplier: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplierExpedition = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplierExpedition: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchOtherItems = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllOtherItemPagingByParam({
        paramFilters: {},
        limit: null,
        page: null,
      });

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataItems: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataGenerateSeq = async (body) => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(
        body
      );
      if (res.ok) {
        return res.data;
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };

  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    return (
      <Fragment>
        <SimpleModal
          title="Tambah Penerimaan Barang Lain"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <ReceivingInputs
                {...this.props}
                dataSupplier={this.state.dataSupplier}
                dataSupplierExpedition={this.state.dataSupplierExpedition}
                inputConfig={this.inputConfig}
              />
              <FlexView vAlignContent="center" className="margin-bottom-10px">
                <h4 className="margin-right-10px">Barang Lain</h4>
                <SimpleButton
                  className={"btn btn-plus background-red margin-left-10px"}
                  onClick={this.handleAddRow}
                  style={{ width: 145 }}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  text={"Tambah Barang"}
                />
              </FlexView>
              <SimpleDataTable
                key={`${this.state.dataTable?.length}-${this.state.pagination.page}`}
                data={this.state.dataTable}
                columns={this.tableColumns}
                toCount={this.state.dataTable.length}
                rowsPerPage={this.state.pagination.limit}
                page={this.state.pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              />
              <br />
              <FlexView hAlignContent="right">
                <SimpleButton
                  type="button"
                  text="Clear"
                  onClick={() => this.handleClearForm()}
                />
                <SimpleButton
                  type="button"
                  text="Simpan"
                  onClick={this.handleSubmit}
                />
                <SimpleButton
                  type="button"
                  text="Batal"
                  onClick={() => this.props.onClickClose()}
                />
              </FlexView>
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleWarningModalVisibility()}
              />
            }
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default withFormGroup(ReceivingCreateUpdate);
